module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "desc"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('strong', [_vm._v("\n          豆瓣"), (_vm.mold === 'quote') ? _c('span', [_vm._v("写了日记")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "timestamp"
  }, [_vm._v("2017-03-01 19:30:41")])])])]), _vm._v(" "), (_vm.mold === 'quote') ? _c('div', {
    staticClass: "article-card"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      豆瓣App 4.12.0 主要更新\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._v("\n      - 可以写读书笔记了，同时支持编辑。随时随地，摘录怦然心动的段落，写下阅读时的随感。来写笔记吧，你...\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.mold === 'comment') ? _c('p', {
    staticClass: "comment"
  }, [_vm._v("\n    可以写读书笔记了，同时支持编辑。随时随地，摘录怦然心动的段落，写下阅读时的随感。来写笔记吧，你\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._m(1), _vm._v(" "), (_vm.mold === 'quote') ? _c('span', {
    staticClass: "btn comment"
  }, [_c('i', [_vm._v("0")])]) : _vm._e(), _vm._v(" "), (_vm.mold === 'quote') ? _c('span', {
    staticClass: "btn retweet"
  }, [_c('i', [_vm._v("1")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "btn more"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/douban-app-logo.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "btn like"
  }, [_c('i', [_vm._v("4")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d892fe2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Card.vue
// module id = 188
// module chunks = 0